import { sum } from "./sum";
import { RowComputeParams } from "./types";

export const TOTAL_RETAIL = (params: RowComputeParams) => {
    const { metricKind, mainRowNodes, getterParams, gridViewRef } = params;
    const values = gridViewRef.current
        ?.getMetricValuesForRows(getterParams.column.getColId(), metricKind, mainRowNodes)
        ?.map((value) => {
            if (isNaN(value)) {
                return 0;
            }
            return value;
        });

    return sum(values);
};
